export const JiraWorkManagementLogoNeutral = () => (
  <svg
    width="504"
    height="48"
    viewBox="0 0 504 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.662 8.47705H55.803V29.5021C55.803 35.0681 53.365 38.8871 47.66 38.8871C45.498 38.8871 43.842 38.519 42.691 38.105V34.1031C43.933 34.6091 45.452 34.885 46.969 34.885C50.466 34.885 51.661 32.769 51.661 29.779V8.47705H51.662Z"
      fill="#44546F"
    />
    <path
      d="M63.346 6.86719C64.956 6.86719 66.106 7.87919 66.106 9.62819C66.106 11.3772 64.957 12.3882 63.346 12.3882C61.735 12.3882 60.585 11.3762 60.585 9.62819C60.585 7.88019 61.735 6.86719 63.346 6.86719ZM61.322 15.7002H65.279V38.7032H61.322V15.7002Z"
      fill="#44546F"
    />
    <path
      d="M75.121 38.7031H71.257V15.7001H75.121V19.7491C76.455 17.0341 78.756 15.1031 83.265 15.3781V19.2421C78.204 18.7361 75.121 20.2551 75.121 25.1311V38.7031Z"
      fill="#44546F"
    />
    <path
      d="M101.803 34.5617C100.331 37.5977 97.571 39.1627 94.029 39.1627C87.91 39.1627 84.828 33.9637 84.828 27.2007C84.828 20.7147 88.048 15.2397 94.489 15.2397C97.847 15.2397 100.424 16.7587 101.803 19.7487V15.6997H105.76V38.7027H101.803V34.5617ZM95.086 35.4817C98.629 35.4817 101.803 33.2277 101.803 28.1217V26.2807C101.803 21.1747 98.905 18.9207 95.546 18.9207C91.084 18.9207 88.783 21.8647 88.783 27.2007C88.783 32.7217 90.991 35.4817 95.086 35.4817Z"
      fill="#44546F"
    />
    <path
      d="M116.105 8.47705H120.384L128.25 34.791L136.854 8.47705H141.73L150.334 34.791L158.201 8.47705H162.341L152.819 38.703H147.528L139.155 12.8931L130.782 38.703H125.63L116.107 8.47705H116.105Z"
      fill="#44546F"
    />
    <path
      d="M162.336 27.1547C162.336 20.2547 166.384 15.2397 173.285 15.2397C180.139 15.2397 184.142 20.2547 184.142 27.1547C184.142 34.0547 180.139 39.1627 173.285 39.1627C166.384 39.1627 162.336 34.0567 162.336 27.1547ZM166.2 27.1547C166.2 31.5257 168.362 35.4817 173.285 35.4817C178.161 35.4817 180.277 31.5257 180.277 27.1547C180.277 22.7837 178.161 18.9207 173.285 18.9207C168.362 18.9207 166.2 22.7847 166.2 27.1547Z"
      fill="#44546F"
    />
    <path
      d="M192.604 38.7031H188.74V15.7001H192.604V19.7491C193.938 17.0341 196.239 15.1031 200.748 15.3781V19.2421C195.687 18.7361 192.604 20.2551 192.604 25.1311V38.7031Z"
      fill="#44546F"
    />
    <path
      d="M204.149 38.703V6.08496H208.106V26.466L217.997 15.7H223.149L212.338 27.017L223.609 38.703H218.227L208.106 27.937V38.703H204.149Z"
      fill="#44546F"
    />
    <path
      d="M240.397 10.9621V38.703H236.256V8.47705H243.433L250.287 25.821L253.094 34.148L255.901 25.821L262.801 8.47705H269.472V38.703H265.331V11.2841L261.789 22.1861L255.118 38.703H251.115L244.537 22.1861L240.396 10.9611L240.397 10.9621Z"
      fill="#44546F"
    />
    <path
      d="M291.688 34.5617C290.216 37.5977 287.456 39.1627 283.914 39.1627C277.795 39.1627 274.713 33.9637 274.713 27.2007C274.713 20.7147 277.933 15.2397 284.374 15.2397C287.732 15.2397 290.309 16.7587 291.688 19.7487V15.6997H295.645V38.7027H291.688V34.5617ZM284.971 35.4817C288.514 35.4817 291.688 33.2277 291.688 28.1217V26.2807C291.688 21.1747 288.79 18.9207 285.431 18.9207C280.969 18.9207 278.668 21.8647 278.668 27.2007C278.668 32.7217 280.876 35.4817 284.971 35.4817Z"
      fill="#44546F"
    />
    <path
      d="M321.175 38.7027H317.218V24.8087C317.218 20.6677 315.562 18.8287 311.789 18.8287C308.109 18.8287 305.579 21.2667 305.579 25.9127V38.7027H301.622V15.6997H305.579V19.4717C307.051 16.7577 309.765 15.2397 312.848 15.2397C318.138 15.2397 321.175 18.8747 321.175 25.2227V38.7017V38.7027Z"
      fill="#44546F"
    />
    <path
      d="M342.288 34.5617C340.816 37.5977 338.056 39.1627 334.514 39.1627C328.395 39.1627 325.313 33.9637 325.313 27.2007C325.313 20.7147 328.533 15.2397 334.974 15.2397C338.332 15.2397 340.909 16.7587 342.288 19.7487V15.6997H346.245V38.7027H342.288V34.5617ZM335.571 35.4817C339.114 35.4817 342.288 33.2277 342.288 28.1217V26.2807C342.288 21.1747 339.39 18.9207 336.031 18.9207C331.569 18.9207 329.268 21.8647 329.268 27.2007C329.268 32.7217 331.476 35.4817 335.571 35.4817Z"
      fill="#44546F"
    />
    <path
      d="M367.726 34.5617C366.253 37.5977 363.494 39.1627 359.951 39.1627C353.879 39.1627 350.843 33.9637 350.843 27.2007C350.843 20.7147 354.017 15.2397 360.412 15.2397C363.77 15.2397 366.347 16.7587 367.726 19.7487V15.6997H371.59V36.6327C371.59 43.3957 368.416 47.9497 360.181 47.9497C356.317 47.9497 354.201 47.4437 351.993 46.7077V42.8437C354.523 43.6717 357.145 44.2237 359.998 44.2237C365.748 44.2237 367.727 41.1417 367.727 36.8627V34.5627L367.726 34.5617ZM361.009 35.4817C364.551 35.4817 367.726 33.2277 367.726 28.1217V26.2807C367.726 21.1747 364.828 18.9207 361.469 18.9207C357.006 18.9207 354.706 21.8647 354.706 27.2007C354.706 32.7217 356.914 35.4817 361.009 35.4817Z"
      fill="#44546F"
    />
    <path
      d="M388.562 39.1627C379.959 39.1627 376.187 34.1937 376.187 27.1547C376.187 20.2087 380.051 15.2397 387.044 15.2397C394.128 15.2397 396.981 20.1627 396.981 27.1547V28.9497H380.189C380.742 32.8597 383.272 35.3897 388.701 35.3897C391.369 35.3897 393.623 34.8837 395.693 34.1477V37.7827C393.807 38.7947 390.909 39.1627 388.562 39.1627ZM380.143 25.5447H392.979C392.749 21.2667 390.817 18.8287 386.86 18.8287C382.673 18.8287 380.557 21.5427 380.143 25.5447Z"
      fill="#44546F"
    />
    <path
      d="M421.224 38.7027H417.267V24.8087C417.267 20.6677 415.611 18.8287 411.838 18.8287C408.158 18.8287 405.628 21.2667 405.628 25.9127V38.7027H401.671V15.6997H405.628V19.4717C407.1 16.7577 409.814 15.2397 412.897 15.2397C416.807 15.2397 419.475 17.2187 420.626 20.8517C421.914 17.3097 424.997 15.2397 428.815 15.2397C433.967 15.2397 436.82 18.7357 436.82 25.2227V38.7017H432.863V25.9117C432.863 21.1737 431.207 18.8277 427.434 18.8277C423.754 18.8277 421.224 21.2657 421.224 25.9117V38.7017V38.7027Z"
      fill="#44546F"
    />
    <path
      d="M453.33 39.1627C444.727 39.1627 440.955 34.1937 440.955 27.1547C440.955 20.2087 444.819 15.2397 451.812 15.2397C458.896 15.2397 461.749 20.1627 461.749 27.1547V28.9497H444.957C445.51 32.8597 448.04 35.3897 453.469 35.3897C456.137 35.3897 458.391 34.8837 460.461 34.1477V37.7827C458.575 38.7947 455.677 39.1627 453.33 39.1627ZM444.911 25.5447H457.747C457.517 21.2667 455.585 18.8287 451.628 18.8287C447.441 18.8287 445.325 21.5427 444.911 25.5447Z"
      fill="#44546F"
    />
    <path
      d="M485.991 38.7027H482.034V24.8087C482.034 20.6677 480.378 18.8287 476.605 18.8287C472.925 18.8287 470.395 21.2667 470.395 25.9127V38.7027H466.438V15.6997H470.395V19.4717C471.867 16.7577 474.581 15.2397 477.664 15.2397C482.954 15.2397 485.991 18.8747 485.991 25.2227V38.7017V38.7027Z"
      fill="#44546F"
    />
    <path
      d="M500.617 34.9758C501.537 34.9758 502.411 34.7908 503.101 34.6538V38.4718C502.411 38.6568 501.628 38.8398 500.432 38.8398C495.51 38.8398 493.118 35.9418 493.118 31.6628V19.3798H489.391V15.6988H493.118V10.8218H496.982V15.6988H503.101V19.3798H496.982V31.5708C496.982 33.5948 498.178 34.9748 500.617 34.9748V34.9758Z"
      fill="#44546F"
    />
    <path
      d="M20.583 8.07913L14.887 30.5631C22.139 32.6121 27.922 29.9481 30.138 21.2001L33.462 8.07812H20.583V8.07913Z"
      fill="url(#paint0_linear_818_520)"
    />
    <path
      d="M12.879 38.4819L18.575 15.9979C11.323 13.9489 5.54 16.6129 3.324 25.3609L0 38.4819H12.879Z"
      fill="#758195"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_520"
        x1="13.2"
        y1="30.6461"
        x2="24.898"
        y2="16.5881"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
